<template>
  <div id="popup-channel">
    <div id="popup-message-window" v-if="showOverlay">
      <a v-if="closable" id="popup-message-close" v-on:click.prevent="closeOverlay">X</a>
      <div v-if="missingTermIdents.length" class="data-missing" id="popup-message-content">
        <Terms :missingTermIdents="missingTermIdents" v-on:terms-agreed="closeOverlay"></Terms>
      </div>
    </div>
  </div>
</template>

<script>

import Terms from '@/components/Terms.vue'

import { mapGetters } from "vuex";

export default {
  name: 'MissingTerms',
  data: function() {
    return {
      missingTermIdents:  this.$parent.missingTermIdents,
      showOverlay: true,
      closable: false,
    }
  },
  mounted() {
      window.scrollTo(0,0);
      document.body.classList.add('formularContent');
      document.getElementById("popup-message-background").classList.add('active');
  },
  methods: {
    closeOverlay() {
      document.body.classList.remove('formularContent');
      document.getElementById("popup-message-background").classList.remove('active');
      this.showOverlay = false;
    }
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy"
    }),
  },
  components: {
    Terms,
  },
}
</script>
